<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Notifications
        <div class="card-header-actions">
          <div class="">
            <!-- <b-button-group>
              <b-button variant="success" @click="ActionBtn('')">ALL</b-button>
              <b-button variant="info" @click="ActionBtn('CRM Cases')">CRM Cases</b-button>
              <b-button variant="warning" @click="ActionBtn('DO')">Delivery Order</b-button>
            </b-button-group> -->
          </div>
        </div>
      </div>

      <b-card no-body>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          hover
          small
          style="font-size: smaller"
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          @row-clicked="rowClicked"
          @filtered="onFiltered"
          show-empty
        >
          <template v-slot:cell(nomor)="data">{{ data.index + 1 }}</template>
          <template v-slot:cell(crewmail)="data">{{
            data.item.crewmail || ""
          }}</template>
          <template v-slot:cell(crewhp)="data">{{
            data.item.crewhp || ""
          }}</template>

          <template v-slot:cell(createdat)="data">
            {{ data.item.createdat | moment("YYYY-MM-DD HH:mm:ss") }}
          </template>

          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click.stop="deleteConfirm(data.item)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:cell(empty)="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="3">
            <div>
              Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
              to
              <span v-if="tblData.page * tblData.limit > tblData.total">{{
                tblData.total
              }}</span>
              <span v-else>{{ tblData.page * tblData.limit }}</span>
              of {{ tblData.total }} entries
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label-cols="5"
              label="Limit per page"
              class="text-right mb-0"
            >
              <b-form-select
                :options="[10, 15, 20, 25]"
                :plain="true"
                v-model="tblData.limit"
                style="width: 80px"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
          </b-col>
          <b-col cols="3">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">
          Warning: You can't undo this action.
        </p>
      </b-modal>
    </b-card>
  </div>
</template>


<script>
import moment from "moment";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import auth from "../../apis/auth.js";
// import customer from "../../apis/crm";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {},
  data() {
    return {
      showDelConfirm: false,
      showLkuOutsource: false,
      horizontal: true,
      showList: true,
      showForm: false,
      filterShow: "Show",
      filter: null,
      filterOn: [],
      tblData: {
        tablename: "notificationmsg",
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        notifyname:'',
        customQuery: '',
        readdate:null
      },
    };
  },
  components: {},
  computed: {
    tblFields() {
      const fields = [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No.",
        },
        {
          key: "notifyname",
          label: "notifyname",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "message",
          label: "Message",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "createdat",
          label: "Created At",
          thClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    requireVendor() {
      const fd = this.golKolektor.find(
        (x) => x.value == this.frmdata.golonganid
      );
      if (fd.text == "Outsourcing") {
        return true;
      }
      return false;
    },
  },
  async created() {
    if(this.$route.params){
      const {notifyname} = this.$route.params;
      this.tblData.notifyname = notifyname;
      if(!notifyname)
        this.tblData.notifyname = '';

    }
  },
  methods: {
    ActionBtn(val){
      this.tblData.notifyname=val;
      this.refresh();
    },
    rowClicked(record, index) {
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      this.readNotif(this.model.notifmsgkey);
      router.push(this.model.route);
    },

    readNotif: async function (key) {
      let readNotif = await customer.readNotif(key);
    },

    onFiltered(filteredItems) {
      // console.log('filter',this.filter);
      //       console.log('filterOn',this.filterOn);
      //       console.log('filteredItems',filteredItems);
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    data: async function (ctx) {
      try {   
        this.tblData.customQuery = `readdate =NULL`;
        this.tblData.customQuery += `&username =${this.$store.state.user.username}`;
        if(this.tblData.notifyname){
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `notifyname =${this.tblData.notifyname}`;
        }

        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        // const list = await crud.list(this.tblData);
        // return list;
      } catch (error) {
          console.log('ero',error)
      }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    close() {
      router.push({ name: "app.home" });
    },
  },
};
</script>
